var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8327 15.8333V4.16667C18.8327 3.24617 18.0865 2.5 17.166 2.5H3.83268C2.91218 2.5 2.16602 3.24617 2.16602 4.16667V15.8333C2.16602 16.7538 2.91218 17.5 3.83268 17.5H17.166C18.0865 17.5 18.8327 16.7538 18.8327 15.8333ZM10.4993 12.2241C10.0542 12.2241 9.60985 12.1044 9.21352 11.8668L3.83268 8.63842V6.69483L10.0705 10.4377C10.3342 10.5957 10.6638 10.5957 10.9291 10.4377L17.1661 6.69483V8.6385L11.786 11.8667C11.3888 12.1044 10.9437 12.2241 10.4993 12.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNotification);
export default __webpack_public_path__ + "static/media/mailNotification.78ca066df5c14103b1ea75d053f3b926.svg";
export { ForwardRef as ReactComponent };